import api from './api';

const ClassContentService = {
  getAll: async (params = {}) => {
    const response = await api.get('/class-contents/', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/class-contents/${id}/`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/class-contents/', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/class-contents/${id}/`, data);
    return response.data;
  },

  partialUpdate: async (id, data) => {
    const response = await api.patch(`/class-contents/${id}/`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/class-contents/${id}/`);
    return response.data;
  }
};

export default ClassContentService;
